import type { QueryClient } from 'react-query';
import {
    IFetchQueryOptions,
    IQueryClient,
} from '@24i/nxg-integration-backstage/src/clients/QueryClient';

export class ReactQueryClient implements IQueryClient {
    constructor(private readonly queryClient: QueryClient) {}

    fetchQuery<T>({ key, queryFn }: IFetchQueryOptions<T>) {
        return this.queryClient.fetchQuery({ queryKey: key, queryFn });
    }
}
